import {inject, Injectable} from '@angular/core';
import Keycloak from 'keycloak-js';

export enum RealmRole {
  SELECTHOR_ADMIN = 'selecthor_admin',
  CUSTOMER_ADMIN = 'customer_admin',
  CUSTOMER_USER = 'customer_user',
  PROVIDER_ADMIN = 'provider_admin',
  PROVIDER_USER = 'provider_user',
  PROVIDER_MANAGER = 'provider_manager',
}

@Injectable({
  providedIn: 'root',
})
export class RoleCheckService {
  private readonly keycloak = inject(Keycloak);

  hasCustomerAdminRole(): boolean {
    return this.keycloak.hasRealmRole(RealmRole.CUSTOMER_ADMIN);
  }

  hasCustomerUserRole(): boolean {
    return this.keycloak.hasRealmRole(RealmRole.CUSTOMER_USER);
  }

  hasSelecthorAdminRole(): boolean {
    return this.keycloak.hasRealmRole(RealmRole.SELECTHOR_ADMIN);
  }

  hasProviderAdminRole(): boolean {
    return this.keycloak.hasRealmRole(RealmRole.PROVIDER_ADMIN);
  }

  hasProviderUserRole(): boolean {
    return this.keycloak.hasRealmRole(RealmRole.PROVIDER_USER);
  }

  hasProviderManagerRole(): boolean {
    return this.keycloak.hasRealmRole(RealmRole.PROVIDER_MANAGER);
  }
}
